var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileBanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.915 21.834a.937.937 0 0 0-1.331 0l-.938.938a.938.938 0 0 0 .666 1.603v2.812a.937.937 0 1 0 1.875 0v-2.812a.937.937 0 0 0 .666-1.603l-.938-.938ZM25.54 25.584a.937.937 0 0 0-.665-.271V22.5a.938.938 0 0 0-1.875 0v2.813a.937.937 0 0 0-.666 1.603l.938.937a.937.937 0 0 0 1.33 0l.938-.937a.936.936 0 0 0 0-1.332Z",
    fill: "#1C3F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.438 25.538v1.65c.002.32.06.636.168.937H8.937a3.75 3.75 0 0 1-3.75-3.75V5.625a3.75 3.75 0 0 1 3.75-3.75H18.314a3.75 3.75 0 0 1 3.75 3.75v14.784c-.161.147-.306.31-.432.488l-.393-.384a2.812 2.812 0 0 0-3.976 0l-.937.937a2.812 2.812 0 0 0 0 3.975l.113.113ZM12.962 18.1a.938.938 0 0 0 1.6-.663 1.875 1.875 0 0 0 1.876-1.875v-.937a1.875 1.875 0 0 0-1.875-1.875h-1.876v-.938H15.5a.938.938 0 0 0 0-1.874h-.938a.938.938 0 0 0-1.874 0 1.875 1.875 0 0 0-1.876 1.874v.938a1.875 1.875 0 0 0 1.876 1.875h1.874v.938H11.75a.938.938 0 0 0 0 1.874h.938c0 .25.098.488.274.663Z",
    fill: "#1C3F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileBanking);
export default __webpack_public_path__ + "static/media/mobile-banking.3ade80352e1d747eb4902797ab85fe16.svg";
export { ForwardRef as ReactComponent };